import React, {Component} from 'react';
const { Link } = require('react-router');

import '../../sass/listpopularsearches.scss';



class ListPopularSearches extends Component
{
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render()
    {
        return (
            <aside className="list-popular-searches">
                <div className="content">
                    <div className="item-searches">
                        <a href="#">pinkbunny</a><span>(31003)</span>
                    </div>
                    <div className="item-searches">
                        <a href="#">pinkbunny</a><span>(31003)</span>
                    </div>
                    <div className="item-searches">
                        <a href="#">pinkbunny</a><span>(31003)</span>
                    </div>
                    <div className="item-searches">
                        <a href="#">pinkbunny</a><span>(31003)</span>
                    </div>
                    <div className="item-searches">
                        <a href="#">pinkbunny</a><span>(31003)</span>
                    </div>
                    <div className="item-searches">
                        <a href="#">pinkbunny</a><span>(31003)</span>
                    </div>
                    <div className="item-searches">
                        <a href="#">pinkbunny</a><span>(31003)</span>
                    </div>
                    <div className="item-searches">
                        <a href="#">pinkbunnydsasdnakja skj asjd</a><span>(31003)</span>
                    </div>
                    <div className="item-searches">
                        <a href="#">pinkbunny</a><span>(31003)</span>
                    </div>
                    <div className="item-searches">
                        <a href="#">pinkbunny</a><span>(31003)</span>
                    </div>
                    <div className="item-searches">
                        <a href="#">pinkbunny</a><span>(31003)</span>
                    </div>
                    <div className="item-searches">
                        <a href="#">pinkbunny</a><span>(31003)</span>
                    </div>
                    <div className="item-searches">
                        <a href="#">pinkbunny</a><span>(31003)</span>
                    </div>
                    <div className="item-searches">
                        <a href="#">pinkbunny</a><span>(31003)</span>
                    </div>
                    <div className="item-searches">
                        <a href="#">pinkbunny</a><span>(31003)</span>
                    </div>
                    <div className="item-searches">
                        <a href="#">pinkbunny</a><span>(31003)</span>
                    </div>
                </div>
            </aside>
        )
    }
}

export default ListPopularSearches;


// WEBPACK FOOTER //
// ./src/components/popularsearches/ListPopularSearches.js